class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');               // <details>
    this.container = this.querySelector('.details-container');  // inner container
    this.summaryToggle = this.querySelector('summary');

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onBodyClick = this.onBodyClick.bind(this);

    this.summaryToggle?.setAttribute('role', 'button');

    this.summaryToggle?.addEventListener('click', this.onSummaryClick);
    this.querySelector('button[type="button"]')?.addEventListener('click', () => this.close(true));
  }

  isOpen() {
    return !!this.details?.hasAttribute('open');
  }

  onKeyDown(e) {
    // use e.key (more reliable than code)
    if (e.key === 'Escape') this.close(false);
  }

  onSummaryClick(e) {
    e.preventDefault();
    this.isOpen() ? this.close(true) : this.open(e);
  }

  onBodyClick(e) {
    if (!this.contains(e.target) || e.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

 open(event) {
  this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

  const details = this.querySelector('details');
  if (!details) return;

  details.setAttribute('open', true);

  document.body.addEventListener('click', this.onBodyClickEvent);
  document.body.classList.add('overflow-hidden');

  const root = this.querySelector('.details-container') || details;

  const first = root.querySelector('[tabindex="-1"]');
  const fallback = root.querySelector('input:not([type="hidden"])') || first;

  if (first && fallback) {
    trapFocus(first, fallback);
  } else if (fallback) {
    fallback.focus?.();
  }
}



  close(focusToggle = true) {
  window.removeTrapFocus?.(focusToggle ? this.summaryToggle : null);

  this.details?.removeAttribute('open');
  document.body.removeEventListener('click', this.onBodyClick);
  document.body.classList.remove('overflow-hidden');
}

}

customElements.define('details-modal', DetailsModal);
